import VueCookies from 'vue-cookies';
import { COOKIES_NAME } from './constants';

export default {
  idEntidade(state) {
    if (!state.entidade) {
      return null;
    }
    return state.entidade.id;
  },
  entidade(state) {
    return state.entidade;
  },
  entidades(state) {
    return state.entidades;
  },
  idEntidadeFromStorage() {
    const idEntidade = VueCookies.get(COOKIES_NAME);
    if (!idEntidade) {
      return null;
    }
    return idEntidade;
  },
  erpCamposIntegracao(state) {
    if (!state.entidade) {
      return null;
    }
    return state.entidade.erpCamposIntegracao;
  },
  loading(state) {
    return state.loading;
  },
  hasControleEntrega(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoControleEntrega;
  },
  hasControleFaturamento(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoControleFaturamento;
  },
  hasIntegracaoAtiva(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoEventHub;
  },
  hasTaxaFinanceira(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoTaxaFinanceira;
  },
  isAprovacaoEnabled(state) {
    if (!state.entidade) {
      return false;
    }
    return !state.entidade.pularAprovacaoFornecedor;
  },
  hasEstoque(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.exibirEstoque;
  },
  hasModuleNotaFiscal(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoNotasFiscais;
  },
};
